module.exports = __webpack_public_path__ + "static/media/19ESCAP16.4f21552e.jpg";